import { RootState } from "@app/redux/root-reducer";

export const selectIsAuthenticated = (store: RootState) =>
  Boolean(store.commonReducer.login?.token);

export const selectRole = (store: RootState) => store.commonReducer.role;
export const selectLoginDataState = (store: RootState) =>
  store.commonReducer.login;
